import React from 'react';
export function Footer() {
  return <footer className="bg-grayDarkest pt-20 pb-10" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-78">
          <div className="col-span-1 md:col-span-2" data-id="element-79">
            <a href="#inicio" className="flex items-center gap-3 mb-6" data-id="element-80">
              <div className="relative w-6 h-6 flex items-center justify-center border border-white" data-id="element-81">
                <div className="w-3 h-3 bg-white" data-id="element-82"></div>
              </div>
              <div className="flex flex-col" data-id="element-83">
                <span className="font-montserrat font-bold text-lg tracking-widest text-white leading-none" data-id="element-84">
                  VELASCO
                </span>
                <span className="font-montserrat text-[8px] tracking-[0.3em] text-grayLightest mt-1" data-id="element-85">
                  & ASOCIADOS
                </span>
              </div>
            </a>
            <p className="text-grayLightest text-sm max-w-sm leading-relaxed font-light" data-id="element-86">
              Defensa legal de élite. Protegiendo sus intereses con estrategia,
              determinación y resultados comprobados durante más de dos décadas.
            </p>
          </div>

          <div data-id="element-87">
            <h4 className="font-montserrat font-bold uppercase tracking-wider mb-6 text-white text-sm" data-id="element-88">
              Navegación
            </h4>
            <ul className="space-y-3" data-id="element-89">
              {['Inicio', 'Áreas de Práctica', 'Equipo', 'Experiencia'].map(item => <li key={item} data-id="element-90">
                    <a href={`#${item.toLowerCase().replace(/ /g, '-').normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`} className="text-grayLightest hover:text-white transition-colors text-sm font-light" data-id="element-91">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          <div data-id="element-92">
            <h4 className="font-montserrat font-bold uppercase tracking-wider mb-6 text-white text-sm" data-id="element-93">
              Legal
            </h4>
            <ul className="space-y-3" data-id="element-94">
              <li data-id="element-95">
                <a href="#" className="text-grayLightest hover:text-white transition-colors text-sm font-light" data-id="element-96">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="text-grayLightest hover:text-white transition-colors text-sm font-light" data-id="element-98">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-99">
                <a href="#" className="text-grayLightest hover:text-white transition-colors text-sm font-light" data-id="element-100">
                  Aviso Legal
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-grayMedium/30 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-101">
          <p className="text-grayLightest text-xs font-light" data-id="element-102">
            Todos los derechos reservados © {new Date().getFullYear()} Velasco
            & Asociados
          </p>
          <div className="flex gap-4" data-id="element-103">
            <div className="w-8 h-8 border border-grayMedium/30 flex items-center justify-center hover:bg-white hover:text-grayDarkest transition-colors cursor-pointer text-white" data-id="element-104">
              <span className="font-montserrat font-bold text-xs" data-id="element-105">IN</span>
            </div>
            <div className="w-8 h-8 border border-grayMedium/30 flex items-center justify-center hover:bg-white hover:text-grayDarkest transition-colors cursor-pointer text-white" data-id="element-106">
              <span className="font-montserrat font-bold text-xs" data-id="element-107">TW</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}